var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.notification.readAt
    ? _c(
        "v-list-item",
        { on: { click: _vm.executeTextAction } },
        [
          _c("v-list-item-title", [
            _vm._v("\n    " + _vm._s(_vm.actions.markAsRead) + "\n  ")
          ])
        ],
        1
      )
    : _c(
        "v-list-item",
        { on: { click: _vm.executeTextAction } },
        [
          _c("v-list-item-title", [
            _vm._v("\n    " + _vm._s(_vm.actions.markAsUnread) + "\n  ")
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eb1c374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb1c374","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Notifications/_Molecules/NotificationMenuList.vue
// module id = null
// module chunks = 